var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRadical = function SvgIconRadical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.9 5.814a1 1 0 0 1 1.287.585l3.563 9.503 3.564-9.503a1 1 0 0 1 .936-.649h10.5a1 1 0 0 1 1 1V9a1 1 0 1 1-2 0V7.75h-8.807L7.687 19.101a1 1 0 0 1-1.873 0l-4.5-12a1 1 0 0 1 .585-1.287"
  })));
};
export default SvgIconRadical;